export default function isDraftStatus(status) {
  return ['draft', 'draft_expired'].includes(status);
}
